import Vue, { nextTick } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import "material-design-icons/iconfont/material-icons.css";
import i18n from "./i18n";
import vuetify from "@/core/plugins/vuetify";
import { ir } from "./check_domain_ir";
import mixins from "./mixin";
import Mapir from 'mapir-vue'

Vue.use(Mapir)
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import DataTable from "laravel-vue-datatable";
import ClipboardJS from "clipboard";
import "vue-toastification/dist/index.css";
import draggable from "vuedraggable";
import mobileTable from "./core/plugins/mobileTable/src/install";
import Echo from "laravel-echo";
// Vue 3rd party plugins
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Toast from "vue-toastification";
//custom
import "./custom";
import "@/assets/css/global.css";
import { mapGetters } from "vuex";
import TerminalTitleRibbon from "./core/plugins/TitleRibbon/install";
import CustomPopup from "./core/plugins/TitleRibbon/plugins/popup/customPopup";
import CustomTabs from "./core/plugins/TitleRibbon/plugins/customTabs/index";
import VueTable from "./core/plugins/TitleRibbon/plugins/vueTable";
import {
  destroyToken,
  getToken,
  saveToken,
} from "./core/plugins/TitleRibbon/assets/js/jwt.service";
import axiosApi from "axios";
import VueSnap from "vue-snap";
import "vue-snap/dist/vue-snap.css";
import Pusher from "pusher-js";
import "@/assets/css/fonts.css";
import "@/assets/css/styleHelpInfo.css";
import "@/assets/css/main.css";
import HelpInfo from "./view/pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "./view/pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

Vue.component("VueCropper", VueCropper);
import VueDragResize from "vue-drag-resize";

Vue.component("vue-drag-resize", VueDragResize);

// import AFRAME from "aframe";
// import "aframe";
// import "@ar-js-org/ar.js/aframe/build/aframe-ar-nft.js";

Vue.use(VueTelInput);
Vue.use(mobileTable);
Vue.use(VueSnap);
Vue.component("draggable", draggable);
Vue.component("HelpInfo", HelpInfo);
Vue.component("HelpInfoWrapper", HelpInfoWrapper);

Vue.config.productionTip = false;
let timer = null;
export const debounce = function (fn, delay) {
  clearTimeout(timer);

  timer = setTimeout(fn, delay);
};
Vue.config.ignoredElements = [/^a-/];
window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
Vue.prototype.$smsUrl = ir("https://core-sms.terminalads.com");
Vue.prototype.$transportUrl = ir("https://core-transport.terminalads.com");
Vue.prototype.$billboardUrl = ir("https://core-billboard.terminalads.com");
Vue.prototype.$showUrl = ir("https://core-show.terminalads.com");
Vue.prototype.$digiUrl = ir("https://core-digi.terminalads.com");
Vue.prototype.$mediaUrl = ir("https://core-media.terminalads.com");
Vue.prototype.$meliUrl = ir("https://core-meli.terminalads.com");
Vue.prototype.$robotUrl = ir("https://core-robot.terminalads.com");
Vue.prototype.$infoUrl = ir("https://core-info.terminalads.com");
Vue.prototype.$sarveLandFront = ir("https://core.terminalads.com/#/login"); //login for logout
Vue.prototype.$sarveLand = ir(process.env.VUE_APP_CoreLandUrl);
Vue.prototype.$paymak_land = ir(process.env.VUE_APP_PayamakLandURL);
Vue.prototype.$terminalApi = ir("api.terminalads.com");
Vue.prototype.$terminal = ir(".terminalads.com");
Vue.prototype.$coreApi3 = ir("https://api.terminalads.com");
Vue.prototype.$coreApi2 = ir("https://api.terminalads.com/api");
Vue.prototype.$coreApi = ir("https://core.terminalads.com");
Vue.prototype.$qrApi = ir("https://core-qr.terminalads.com/api");
Vue.prototype.$mediaApi = ir("https://media.terminalads.com");
Vue.prototype.$linkApi = ir("https://link.terminalads.com");
Vue.prototype.$robotApi = ir("https://robot-api.terminalads.com/api");
Vue.prototype.$payamakApi = ir("https://sms-api.terminalads.com/api");
Vue.prototype.$payamakApi2 = ir("https://sms-api.terminalads.com/api/");
Vue.prototype.$coreLogin = ir("https://core.terminalads.com/#/login");
Vue.prototype.$fileApi = ir("https://file-api.terminalads.com/api");
Vue.prototype.$fileApi2 = ir("https://file-api.terminalads.com/api/");
Vue.prototype.$corepayamakApi = ir("https://core-sms.terminalads.com");
Vue.prototype.$terminalads = ir("https://terminalads.com");
Vue.prototype.$coreqrOrigin = ir("core-qr.terminalads.com");
Vue.prototype.$robotCoreApi = ir("https://core-robot.terminalads.com");
Vue.prototype.$coreqrApi = ir("https://core-qr.terminalads.com");
Vue.prototype.$digiApi = ir("https://core-digi.terminalads.com");
Vue.prototype.$appUrl =
  ir(process.env.VUE_APP_URL) || ir("https://core-qr.terminalads.com/api");
Vue.prototype.$coreterminalUrl = ir("core.terminalads.com");
Vue.prototype.$roboatUrl = ir("https://robot-api.terminalads.com");
Vue.prototype.$rootUrl = ir(process.env.VUE_APP_ROOT);
Vue.prototype.$aiApi = ir("https://ai-api.terminalads.com/api");
Vue.prototype.$qrUrl = ir("https://core-qr.terminalads.com");
Vue.prototype.$corePanelUrl = ir("https://core_panel.terminalads.com");
Vue.prototype.$cdnUrl = ir("https://cdn.terminalads.com");
Vue.prototype.$services = {
  1: ir("https://core.terminalads.com"),
  2: ir("https://core-sms.terminalads.com"),
  3: ir("https://core-qr.terminalads.com"),
  4: ir("https://core-robot.terminalads.com"),
  5: ir("https://core-billboard.terminalads.com"),
  10: ir("https://core-info.terminalads.com"),
  11: ir("https://core-file.terminalads.com"),
  13: ir("https://core-digi.terminalads.com"),
  14: ir("https://core-graphic.terminalads.com"),
};

export let dataTableProps = {
  tableProps: {
    search: "",
    length: 10,
    column: "id",
    dir: "desc",
    page: 1,
  },
  pagination: {
    align: "right",
    limit: 4,
  },
  translate: {
    nextButton: i18n.t("nextButton"),
    previousButton: i18n.t("previousButton"),
    rowsPerPageText: i18n.t("rowsPerPageText"),
    noDataText: i18n.t("noDataText"),
    placeholderSearch: i18n.t("placeholderSearch"),
  },
};

let id_token = localStorage.getItem("id_token");
const axios = axiosApi.create({
  baseURL: Vue.prototype.$appUrl,
  timeout: 50000,
  headers: {
    Authorization: !!id_token ? "Bearer " + id_token : undefined,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  // headers: {

  //   Authorization: !!id_token ? "Bearer " + id_token : undefined,
  //   Accept: "application/json",
  //   "Access-Control-Allow-Origin": "*",
  //   "Content-Type": "application/json",
  // },
});

Vue.prototype.$api = axios;
window.url = Vue.prototype.$appUrl;

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: "pusher",
  key: "local",
  cluster: "mt1",
  forceTLS: true,
  authEndpoint: Vue.prototype.$coreApi2 + "/socket/auth",
  wsPort: 6211,
  wsHost: Vue.prototype.$terminalApi,
  auth: {
    // headers: {
    //   ...(id_token ? { Authorization: `Bearer ${id_token}` } : {}),
    //   Accept: "application/json",
    //   "Access-Control-Allow-Origin": "*",
    //   "Content-Type": "application/json",
    // },

    headers: {
      Accept: "application/json",
      Authorization: !!id_token ? "Bearer " + id_token : undefined,
    },
  },
});
Vue.prototype.$echo = echo;

export const rbland = axiosApi.create({
  baseURL: ir(process.env.VUE_APP_RB),
  timeout: 15000,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export const rbAxios = axiosApi.create({
  baseURL: ir(process.env.VUE_APP_ROBOT),
  timeout: 60000,
  headers: {
    Authorization: "Bearer " +  localStorage.getItem("id_token"),
    Accept: "application/json",
    // "Access-Control-Allow-Origin": "*",
    // "Content-Type": "application/json",
  },
});

export const RobotAxios = axiosApi.create({
  baseURL: ir(process.env.VUE_APP_CRAWLER),
  timeout: 15000,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export const SmsAxios = axiosApi.create({
  baseURL: Vue.prototype.$payamakApi2,
  timeout: 15000,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

// --- هدایت به صفحه قطعی سرور ---
let isRedirectingToServerDown = false;

const applyServerDownInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (axiosApi.isCancel(error)) {
        return Promise.reject(error);
      }

      const isNetworkError = !error.response && error.message === 'Network Error';
      const isTimeout = error.code === 'ECONNABORTED' || error.message.includes('timeout');      
      const serverDownStatuses = [502, 503, 504];
      const isServerError = error.response && serverDownStatuses.includes(error.response.status);

      if (isNetworkError || isServerError || isTimeout) {
        if (!isRedirectingToServerDown && router.currentRoute.name !== 'ServerDown') {
          isRedirectingToServerDown = true;
          
          router.push({ name: 'ServerDown' }).then(() => {
            setTimeout(() => { isRedirectingToServerDown = false; }, 1000);
          }).catch(() => {
             isRedirectingToServerDown = false;
          });
        }
      }
      return Promise.reject(error);
    }
  );
};

applyServerDownInterceptor(axios);
applyServerDownInterceptor(rbland);
applyServerDownInterceptor(rbAxios);
applyServerDownInterceptor(RobotAxios);
applyServerDownInterceptor(SmsAxios);
// ---   قطعی سرور ---


Vue.use(mixins);

Vue.component("customPopup", CustomPopup);
Vue.component("customTabs", CustomTabs);
Vue.component("vueTable", VueTable);

let dashboardConfig = {
  announcement: {
    img:
      Vue.prototype.$robotCoreApi +
      "/advertisement-billboard-6097659-5013090.png", // url
    text: "QR ثبت شده", // any
    url: router.resolve({ name: "send.sms.divar" }).href, // page to go
  },
  numbers: {
    img:
      Vue.prototype.$robotCoreApi +
      "/advertisement-billboard-6097659-5013090.png", // require from local assets
    text: "شماره ها",
    url: router.resolve({ name: "divar.report" }).href,
  },
  counter: new Promise((resolve) => {
    resolve({
      announcement: 0,
      numbers: 0,
    });
  }),
};
let static_top_menu = [];
const img = require("/public/media/img/logo.webp");
Vue.use(TerminalTitleRibbon, {
  store,
  axios, // an inctance of axios *reqire*
  config: () => ({
    dashboardConfig, // dashboard data
    static_top_menu, // links in top of menu
    header_logo: img, // set a getter in config.getters store
  }),
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"), // send Authorization with Bearer anytime.
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  permissions: () => store.state.ability, // this plugin need user permission for check user access.
  core_url: Vue.prototype.$coreApi3,
  front_url: Vue.prototype.$coreApi,
  sid: 3, // send ID for each project
  onChangeLanguage(lang) {
    i18n.locale = lang;
    ///// for update title of document
    const currentRoute = router.currentRoute;
    const titleKey = currentRoute.meta.title;
    const defaultTitle = i18n.t("qr_management") || "QR Management";
    if (titleKey && i18n.t(titleKey)) {
      document.title = `${defaultTitle} - ${i18n.t(titleKey)}`;
    } else if (defaultTitle !== undefined) {
      document.title = `${defaultTitle}`;
    } else {
      document.title = "TerminalAds";
    }
  },
});

Vue.use(Toast, {
  position: "top-center",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: true,
  maxToasts: 1,
  newestOnTop: true,
  color: "black",
});

Vue.use(DataTable);
Vue.use(VuePersianDatetimePicker, {
  name: "date-picker",
  props: {
    autoSubmit: true,
    clearable: true,
    format: "YYYY-MM-DD HH:mm:ss",
    displayFormat: "jYYYY-jMM-jDD HH:mm:ss",
  },
});

$("input[name='table-search']")
  .parent()
  .removeClass("offset-md-6")
  .addClass("ms-auto");

export const Bus = new Vue({
  methods: {
    setProp(name, value) {
      this[name] = value;
    },
    getProp(name) {
      return this[name];
    },
  },
});

Vue.mixin({
  methods: {
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },
    validateInput(input) {
      if (input === undefined || input == null) return "";
      let str = input.toString().trim();
      if (str === "") return "";
      return str;
    },
    use_lang(input) {
      let lang = i18n.locale || "fa";
      let str1 = this.validateInput(input);
      if (typeof str1 !== "string") str1 = str1 == null ? "0" : str1.toString();
      switch (lang) {
        case "fa":
          str1 = this.persian(str1);
          break;
        case "en":
          str1 = this.english(str1);
          break;
        case "ar":
          str1 = this.arabic(str1);
          break;

        default:
          str1 = this.persian(str1);
          break;
      }
      return str1;
    },
    persian(input) {
      let str1 = this.validateInput(input);
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      str1 = str1.replace(/٠/gim, "۰");
      str1 = str1.replace(/١/gim, "۱");
      str1 = str1.replace(/٢/gim, "۲");
      str1 = str1.replace(/٣/gim, "۳");
      str1 = str1.replace(/٤/gim, "۴");
      str1 = str1.replace(/٥/gim, "۵");
      str1 = str1.replace(/٦/gim, "۶");
      str1 = str1.replace(/٧/gim, "۷");
      str1 = str1.replace(/٨/gim, "۸");
      str1 = str1.replace(/٩/gim, "۹");
      return str1;
    },

    english(input) {
      let str1 = this.validateInput(input);
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      str1 = str1.replace(/٠/gim, "0");
      str1 = str1.replace(/١/gim, "1");
      str1 = str1.replace(/٢/gim, "2");
      str1 = str1.replace(/٣/gim, "3");
      str1 = str1.replace(/٤/gim, "4");
      str1 = str1.replace(/٥/gim, "5");
      str1 = str1.replace(/٦/gim, "6");
      str1 = str1.replace(/٧/gim, "7");
      str1 = str1.replace(/٨/gim, "8");
      str1 = str1.replace(/٩/gim, "9");
      return str1;
    },

    arabic(input) {
      let str1 = this.validateInput(input);
      str1 = str1.replace(/0/gim, "٠");
      str1 = str1.replace(/1/gim, "١");
      str1 = str1.replace(/2/gim, "٢");
      str1 = str1.replace(/3/gim, "٣");
      str1 = str1.replace(/4/gim, "٤");
      str1 = str1.replace(/5/gim, "٥");
      str1 = str1.replace(/6/gim, "٦");
      str1 = str1.replace(/7/gim, "٧");
      str1 = str1.replace(/8/gim, "٨");
      str1 = str1.replace(/9/gim, "٩");
      str1 = str1.replace(/۰/gim, "٠");
      str1 = str1.replace(/۱/gim, "١");
      str1 = str1.replace(/۲/gim, "٢");
      str1 = str1.replace(/۳/gim, "٣");
      str1 = str1.replace(/۴/gim, "٤");
      str1 = str1.replace(/۵/gim, "٥");
      str1 = str1.replace(/۶/gim, "٦");
      str1 = str1.replace(/۷/gim, "٧");
      str1 = str1.replace(/۸/gim, "٨");
      str1 = str1.replace(/۹/gim, "٩");
      return str1;
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
});
router.beforeEach((to, from, next) => {
  const defaultTitle = i18n.t("qr_management") || "QR Management";
  const pageTitle = to.meta.title ? i18n.t(to.meta.title) : null;
  document.title = pageTitle ? `${defaultTitle} - ${pageTitle}` : defaultTitle;

  next();
});
router.afterEach((to) => {
  Vue.nextTick().then(() => {
    const titleKey = to.meta.title;
    const defaultTitle = i18n.t("qr_management") || "QR Management";
    if (titleKey && i18n.t(titleKey)) {
      document.title = `${defaultTitle} - ${i18n.t(titleKey)}`;
    } else if (defaultTitle !== undefined) {
      document.title = `${defaultTitle}`;
    } else {
      document.title = "TerminalAds";
    }
  });
});

window.Vue = new Vue({
  data() {
    return {
      gotToken: false,
      isTranslating: false,
    };
  },
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
  created() {
    this.$api.defaults.headers["lang"] = this.$i18n.locale || "fa";
    document.body.className = `lang-${this.$i18n.locale || "fa"}`;
    setInterval(() => {
      document.body.className = `lang-${this.$i18n.locale || "fa"}`;
    }, 1000);
  },
  methods: {
    async fetch() {
      let result = null;

      if (!getToken()) {
        const { origin, hash } = window.location;

        destroyToken(origin, hash.substring(1));
      } else {
         try {
          await this.checkTokenAsync(getToken());
        } catch (err) {
          console.error("Token verification error:", err);
        }
        await $.ajax({
          url: `${Vue.prototype.$qrApi}/user/abilities`,
          async: false,
          fn: this.fetch,
          headers: {
            Authorization: "Bearer " + getToken(),
            ACCEPT: "application/json",
          },
          success: (data) => {
            this.permissions();
            this.gotToken = true;
            this.$store.dispatch("global/isLoaded", true);
            this.$store.state.ability = data.data;
            //store.commit("setAbilities", data.data);
            result = data.data;
          },
            error: (xhr, textStatus, errorThrown) => {
            if (textStatus === 'abort') {
              return;
            }

          const serverDownStatuses = [502, 503, 504];
            if (xhr.status === 0 || serverDownStatuses.includes(xhr.status)) {
              if (!isRedirectingToServerDown && router.currentRoute.name !== 'ServerDown') {
                isRedirectingToServerDown = true;
                router.push({ name: 'ServerDown' }).then(() => {
                   setTimeout(() => { isRedirectingToServerDown = false; }, 1000);
                }).catch(() => {
                   isRedirectingToServerDown = false;
                });
              }
            }
          }       
         });
        
      }
      return result;
    },
    setToken() {
      let url = window.location.href;
      const start = url.indexOf("?");
      const end = url.indexOf("#");
      url = url.substring(start, end);
      let token = url.split("token=")[1];
      if (token) {
        saveToken(token);
        return window.history.pushState(
          "dashboard",
          "Title",
          "/" + window.location.hash,
        );
      }
    },
    permissions() {
      Vue.directive("status", (element, binding) => {
        const value = binding.value;
        const abilities = this.$store.state.ability;

        if (
          abilities.indexOf(value + ":active") < 0 &&
          abilities.indexOf(value + ":show") < 0
        ) {
          $(element).remove();
          return;
        }
        if (abilities.indexOf(value + ":show") > -1) {
          $(element).attr("disabled", true);
        }
      });
    },
  },
  async beforeMount() {
    this.setToken();

    router.beforeResolve(async (to, from, next) => {
      window.Vue.$store.getters["global/isLoaded"] || (await this.fetch());
      if (to.meta.permission && !this.ribbon_can(to.meta.permission))
        next({ name: "dashboard" });
      else next();
    });
  },
}).$mount("#app");
